import TechAddToPortfolioFail from './TechAddToPortfolioFail';

export default TechAddToPortfolioFail;
